/*
创建者 李伟(2018.5.31)
商品列表页面
*/
<template>
  <div id="goods-list-page">
    <div
      class="breadcrumb wrapper"
      style="line-height:30px;"
    >
      <span>
        <router-link to="/">首页</router-link>
      </span>
      <span class="arrow">&gt;</span>
      <span>
        <router-link to="/landmark-superior-product">地标优品</router-link>
      </span>
      <span class="arrow">&gt;</span>
      <span>{{this.regionName}}</span>
    </div>
    <div class="container wrapper clearfix">

      <!-- 右侧商品 -->
      <div
        class="right"
        id="result"
      >
        <div
          class="shop_con_list"
          id="main-nav-holder"
        >
          <!-- <nav
            class="sort-bar"
            id="main-nav"
          >
            <input
              type="hidden"
              value="desc"
              name="order"
            >
            <div class="sortbar-array"> 排序方式：
              <ul>
                <li
                  :class="{selected:search_type==0}"
                  @click="searchByType(0)"
                >
                  <a
                    href="javascript:void(0)"
                    title="点击按默认从低到高排序"
                    :class="{'desc':order=='order','asc':order=='asc'}"
                  >
                    默认<i></i>
                  </a>
                </li>
                <li
                  :class="{selected:search_type==1}"
                  @click="searchByType(1)"
                >
                  <a
                    href="javascript:void(0)"
                    title="点击按销量从高到低排序"
                    :class="{'desc':order=='order','asc':order=='asc'}"
                  >
                    销量<i></i>
                  </a>
                </li>
                <li
                  :class="{selected:search_type==2}"
                  @click="searchByType(2)"
                >
                  <a
                    href="javascript:void(0)"
                    title="点击按价格从高到低排序"
                    :class="{'desc':order=='order','asc':order=='asc'}"
                  >
                    价格<i></i>
                  </a>
                </li>
              </ul>
            </div>
          </nav> -->
          <p
            v-if="!this.loading&&this.list.length==0"
            style="color:red;font-size:20px;text-align:center;margin-top:20px;"
          >
            抱歉,暂无此类商品!
          </p>
          <right-goods :data="list"></right-goods>
          <div
            v-show="total>0"
            class="page-wrapper"
          >
            <Page
              :total="total"
              :current="page"
              :page-size="pageSize"
              show-elevator
              show-total
              @on-change="changePage"
            >
            </Page>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import rightGoods from "./module-right-goods.vue";
import { getQueryGoodsByProvince } from "api/home";
export default {
  components: {
    rightGoods,
  },
  data() {
    return {
      list: [],
      regionId: "",
      regionName: "",
      page: 1,
      pageSize: 12,
      loading: false,
      total: 0,
    };
  },
  created() {
    this.regionName = this.$route.query.aname;
    this.regionId = this.$route.query.regionId;
    this.fetchData();
  },
  methods: {
    changePage(index) {
      this.page = index;
      this.fetchData();
    },
    fetchData() {
      let params = {
        pageNo: this.page,
        pageSize: this.pageSize,
        regionId: this.regionId,
      };
      getQueryGoodsByProvince(params).then((json) => {
        if (json.resCode == 1) {
          this.loading = false;
          this.list = json.data.list;
          this.total = json.data.total;
        } else {
          console.log("获取商品列表数据错误！");
        }
      });
    },
  },
};
</script>
<style scoped>
#goods-list-page .wrapper {
  width: 1200px !important;
  margin: 0 auto;
}
.page-wrapper {
  margin: 20px 0;
  text-align: right;
}
#result {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// index.vue?1437e39d